import React from 'react';
import buttonStyles from './Button.module.css';
import styles from './SelectActionModal.module.css';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    styled,
} from '@mui/material';

const BootstrapDialog = styled(Dialog)(() => ({
    '& .MuiDialog-container': {
        alignItems: 'start',
    },
    '& .MuiPaper-root': {
        padding: '1rem',
        borderRadius: '0.7rem',
    },
}));

export type ActionModal = {
    title: string;
    onClick: () => void;
};

export const SelectActionModal: React.FC<{
    open: boolean;
    title: string;
    body: string;
    actions: ActionModal[];
}> = ({ open, title, body, actions }) => {
    return (
        <BootstrapDialog open={open}>
            <DialogTitle className={styles.modalDialogTitle}>
                {title}
            </DialogTitle>
            <DialogContent className={styles.modalDialogBody}>
                {body}
            </DialogContent>
            <DialogActions className={styles.modalDialogSelectActions}>
                {actions.map((action, index) => (
                    <Button
                        key={`modal_action_${index}`}
                        className={`${buttonStyles.customButton} ${buttonStyles.customButtonLabel}`}
                        onClick={() => action.onClick()}
                    >
                        {action.title}
                    </Button>
                ))}
            </DialogActions>
        </BootstrapDialog>
    );
};
